import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaPlus, FaTimes } from 'react-icons/fa';
import * as api from '~/Services/Service';

const formatarData = (data) => {
  if (!data) return '-';
  const d = new Date(data);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

const ModalOcorrencias = ({ show, codigoAtivo, onClose }) => {
  const [ocorrencias, setOcorrencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [texto, setTexto] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (show) carregarOcorrencias();
  }, [show]);

  const carregarOcorrencias = async () => {
    setLoading(true);
    try {
      const resp = await api.ativoManutencaoListarOcorrencias(codigoAtivo);
      setOcorrencias(resp || []);
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao carregar ocorrências';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleIncluir = async () => {
    if (!titulo.trim()) { toast.error('Título é obrigatório'); return; }
    if (!texto.trim()) { toast.error('Texto é obrigatório'); return; }
    setSalvando(true);
    try {
      await api.ativoManutencaoSalvarOcorrencia({ codigo_ativo: codigoAtivo, titulo, texto });
      toast.success('Ocorrência registrada');
      setTitulo('');
      setTexto('');
      carregarOcorrencias();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir ocorrência';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" centered backdrop="static">
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ color: '#fff', fontSize: 16 }}>Ocorrências do Ativo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-3">Carregando...</div>
        ) : (
          <>
            <Table size="sm" hover style={{ fontSize: 13 }}>
              <thead style={{ background: '#f4f5f7' }}>
                <tr>
                  <th style={{ width: 140 }}>Data</th>
                  <th>Título</th>
                  <th>Texto</th>
                  <th>Usuário</th>
                </tr>
              </thead>
              <tbody>
                {ocorrencias.length === 0 ? (
                  <tr><td colSpan={4} className="text-center text-muted py-3">Nenhuma ocorrência registrada</td></tr>
                ) : ocorrencias.map((o, i) => (
                  <tr key={o.codigo || `${o.data}-${i}`}>
                    <td>{formatarData(o.data)}</td>
                    <td>{o.titulo}</td>
                    <td style={{ whiteSpace: 'pre-wrap' }}>{o.texto}</td>
                    <td>{o.nome_usuario || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <hr />
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Nova Ocorrência</div>
            <Form.Group className="mb-2">
              <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Título <span className="text-danger">*</span></Form.Label>
              <Form.Control
                value={titulo}
                onChange={(e) => setTitulo(e.target.value)}
                placeholder="Título da ocorrência"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Texto <span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={texto}
                onChange={(e) => setTexto(e.target.value)}
                placeholder="Descrição da ocorrência"
              />
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button size="sm" variant="success" onClick={handleIncluir} disabled={salvando}>
                <FaPlus style={{ marginRight: 4 }} />
                {salvando ? 'Incluindo...' : 'Incluir'}
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onClose}>
          <FaTimes style={{ marginRight: 4 }} />
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalOcorrencias;
